module.exports = __webpack_public_path__ + "6cbbf90e959066656ea0900067e0801c.svg";